import React, { useState, useEffect } from "react";
import {
    Card,
    Table
} from "react-bootstrap";
import { Button } from 'primereact/button';
import axios from 'axios';
import config from '../config';
import { useAuth } from '../context/AuthContext';

import { Avatar } from 'primereact/avatar';
import noUserImg from '../assets/images/no_user.png';
import { AutoComplete } from "primereact/autocomplete";
import { Tooltip } from 'primereact/tooltip';
import { Sidebar } from 'primereact/sidebar';
import Meeting_notes_form from './Meeting_notes_form';
import { Accordion, AccordionTab } from 'primereact/accordion';
import gifImage from '../assets/images/Logo_animation.gif'
import { Calendar } from 'primereact/calendar';


const Meeting_notes = () => {
    const { accessToken, userId } = useAuth(); // Get access token for authorization
    const [minutesOfMeeting, setMinutesOfMeeting] = useState(null);
    const [loading, setLoading] = useState(true);
    const [visibleRight, setVisibleRight] = useState(false);
    const currentDate = new Date();
    const [selectedDate, setSelectedDate] = useState(currentDate);
    const [month, setMonth] = useState(currentDate.getMonth() + 1);
    const [year, setYear] = useState(currentDate.getFullYear());
    const [brands, setBrands] = useState([]);
    const [filteredBrands, setFilteredBrands] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState(null);



    // Fetch brands from the API
    const fetchBrands = async () => {
        try {
            const response = await axios.get(`${config.apiBASEURL}/projectRoutes/fetchallbrands`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            setBrands(response.data || []);
        } catch (error) {
            console.error("Error fetching brands:", error);
        }
    };
    useEffect(() => {
        fetchBrands();
    }, [accessToken]);


    // Filter brands for autocomplete
    const searchBrands = (event) => {
        const query = event.query.toLowerCase();
        setFilteredBrands(
            brands.filter((brand) =>
                brand.brand_name.toLowerCase().includes(query)
            )
        );
    };



    const fetchMinutesOfMeeting = async () => {
        if (!userId) return;

        try {
            setLoading(true);

            const params = { month, year };

            // Only add brand_id if brand is selected
            if (selectedBrand && selectedBrand.brand_id) {
                params.brand_id = selectedBrand.brand_id;
            }

            const response = await axios.get(
                `${config.apiBASEURL}/BrandBookRoutes/fetchUserMeetings/${userId}`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                    params
                }
            );

            setMinutesOfMeeting(response.data.data);
        } catch (err) {
            console.error("Error fetching minutes of meeting:", err);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
    };


    useEffect(() => {
        fetchMinutesOfMeeting();
    }, [userId, accessToken, month, year, selectedBrand]); // Added month and year as dependencies


    const handleSuccess = () => {
        // Close the sidebar
        setVisibleRight(false);

        // Optionally refetch the meeting data
        fetchMinutesOfMeeting();

        // Optional: show a success toast/message
        // toast.success('Meeting notes saved successfully!');
    };

    return (
        <>
            <Card className="shadow-0 p-0">
                <Card.Header className="h6 d-flex justify-content-between align-items-center bg-light">
                    Meeting Notes
                    <Button
                        label='Meeting'
                        icon='pi pi-plus'
                        severity='warning'
                        className='border-0 py-2'
                        onClick={() => setVisibleRight(true)}
                    />
                </Card.Header>
                <Card.Body className="px-0">
                    <div className="d-flex flex-wrap justify-content-end alignitems-center gap-2 mb-4 filt_div">
                        <div>
                            <AutoComplete
                                value={selectedBrand}
                                suggestions={filteredBrands}
                                completeMethod={searchBrands}
                                field="brand_name"
                                onChange={(e) => setSelectedBrand(e.value)}
                                placeholder="Search Brand"
                                className="w-100"
                            />

                        </div>
                        <div>
                            <Calendar
                                value={selectedDate}
                                onChange={(e) => {
                                    setSelectedDate(e.value);
                                    setMonth(e.value ? new Date(e.value).getMonth() + 1 : null);
                                    setYear(e.value ? new Date(e.value).getFullYear() : null);
                                }}
                                view="month"
                                dateFormat="mm/yy"
                                style={{ width: '100px' }}
                                className="me-2"
                            />
                        </div>

                    </div>
                    {loading ? (
                        <div className="text-center py-4 text-muted">
                            <img
                                src={gifImage} alt="gif" 
                                style={{ width: '150px', height: '180px', opacity: '0.5' }}
                            />
                           
                        </div>
                    ) : (!minutesOfMeeting || minutesOfMeeting.length === 0) ? (
                        <div className="text-center py-4 text-muted">
                            <strong>No meetings found.</strong>
                        </div>
                    ) : (
                        <Accordion activeIndex={0}>
                            {minutesOfMeeting.map((meeting, index) => (
                                <AccordionTab
                                    key={meeting.meeting_id || index} // Assuming you have a unique `meeting_id`
                                    header={
                                        <span className="w-full">
                                            <span>
                                                <small>Meet Title</small> : {meeting.meeting_title}
                                                <span className="d-block mt-2">
                                                    <small>Brand</small> : {meeting.brand} | {new Date(meeting.date).toLocaleDateString('en-GB')}
                                                </span>
                                            </span>

                                        </span>
                                    }
                                >
                                    <div className="meet_notul">
                                        <Table size="sm" striped className="mb-0">
                                            <tbody>
                                                <tr>
                                                    <td><small className="d-block text-muted">Project Name</small></td>
                                                    <td>{meeting.project || '-'}</td>
                                                </tr>
                                                <tr>
                                                    <td><small className="d-block text-muted">Meeting Type</small></td>
                                                    <td>{meeting.meeting_type || '-'}</td>
                                                </tr>
                                                <tr>
                                                    <td><small className="d-block text-muted">Meeting Members</small></td>
                                                    <td>{meeting.meeting_members || '-'}</td>
                                                </tr>
                                                <tr>
                                                    <td><small className="d-block text-muted">Agenda</small></td>
                                                    <td>{meeting.agenda || '-'}</td>
                                                </tr>
                                                <tr>
                                                    <td><small className="d-block text-muted">Action Items</small></td>
                                                    <td>{meeting.action_items || '-'}</td>
                                                </tr>
                                                <tr>
                                                    <td><small className="d-block text-muted">Discussions</small></td>
                                                    <td>{meeting.discussions || '-'}</td>
                                                </tr>
                                                <tr>
                                                    <td><small className="d-block text-muted">Decisions</small></td>
                                                    <td>{meeting.decisions || '-'}</td>
                                                </tr>
                                                <tr>
                                                    <td><small className="d-block text-muted">Client Updates</small></td>
                                                    <td>{meeting.client_updates || '-'}</td>
                                                </tr>
                                                <tr>
                                                    <td><small className="d-block text-muted">Added By:</small></td>
                                                    <td className="d-flex align-items-center"><Avatar
                                                        image={meeting.creator.image_url || noUserImg}
                                                        shape="circle"
                                                        style={{ width: '24px', height: '24px' }}
                                                        className="me-2"
                                                    />
                                                        <small className="text-danger"> {meeting.creator.name}</small></td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </AccordionTab>
                            ))}
                        </Accordion>
                    )}
                </Card.Body>
            </Card>

            <Sidebar visible={visibleRight} position="right" onHide={() => setVisibleRight(false)} style={{ width: '550px' }}>
                <Meeting_notes_form onSuccess={handleSuccess} />
            </Sidebar>
        </>
    );
};

export default Meeting_notes